import { TutorialDefinition, TutorialScene } from '../TutorialEngine.js';
import { COLORS } from '../../rendering/Renderer.js';
import { IgnitionVortexTutorialState } from './IgnitionTutorialAdapter.js';

type VState = IgnitionVortexTutorialState;

const PARTIAL = '0203,1213,2223,3646,3545,3444,2324,3242,4142';
const PARTIAL_GATED = `${PARTIAL}|E4=C5`;
const SOLVED = '0203,1213,2223,3646,3545,3444,2324,3242,3141,1121,4252,5152|E4=C5';

const scenes: TutorialScene[] = [
    // Scene 1: Toggle Gates — animate the gate placement flow
    {
        gameState: { fuses: PARTIAL } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click Activate Vortex\nto place a gate pair', cell: 'C2', anchor: 'center' },
            { type: 'text-label', text: 'Pair must be linked\nin the Vortex Hub', cell: 'E5', anchor: 'center' },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { fuses: PARTIAL },
                { fuses: PARTIAL, gateMode: true },
                { fuses: PARTIAL_GATED, gateMode: true },
                { fuses: PARTIAL_GATED },
            ] as VState[],
        },
    },

    // Scene 2: Activation — toggle an unblocked pair active; a blocked pair stays amber
    {
        gameState: { fuses: '1525', gateMode: true, extraGates: [['B5', 'D5']] } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click a pair\nto activate it', cell: 'D3', anchor: 'center', color: COLORS.teal },
            { type: 'text-label', text: 'Fuses block\ngate activation', cell: 'B5', anchor: 'far-above', color: COLORS.amber },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { fuses: '1525', gateMode: true, extraGates: [['B5', 'D5']] },
                { fuses: '1525|E4=C5', gateMode: true, extraGates: [['B5', 'D5']] },
            ] as VState[],
        },
    },

    // Scene 3: Fire teleportation
    {
        gameState: { fuses: PARTIAL_GATED, selectedDigit: 3 } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Fire enters\na gate...', cell: 'E3', anchor: 'far-left' },
            { type: 'text-label', text: '...exits from\nthe other side', cell: 'C5', anchor: 'far-right' },
            { type: 'pulse', cell: 'E4', color: COLORS.purple },
            { type: 'pulse', cell: 'C5', color: COLORS.purple },
        ],
    },

    // Scene 4: Full solved state
    {
        gameState: { fuses: SOLVED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Gates share\nignition time', cell: 'C3', anchor: 'center', color: COLORS.amber },
            { type: 'pulse', cell: 'E4', color: COLORS.purple },
            { type: 'pulse', cell: 'C5', color: COLORS.purple },
        ],
    },
];

/**
 * Vortex Ignition tutorial: 4 scenes on a 6×6 vortex grid with digits 0-3.
 * Teaches fire teleportation through Vortex gates.
 */
export const IGNITION_VORTEX_TUTORIAL: TutorialDefinition = {
    gameType: 'ignition-vortex',
    gridCode: '6/0-3:0C4,1F3,2C1,3A3',
    scenes,
    previewScene: 3,
};
